export function getRouteAccessDecision({ pathname, can, rules }) {
    const matchedRule = rules.find(rule => rule.match(pathname));

    if (!matchedRule) {
        return { allowed: true };
    }

    const hasAllRequiredPermissions = matchedRule.allow.every(permission =>
        can(permission)
    );

    if (!hasAllRequiredPermissions) {
        return { allowed: false, redirectTo: '/maintenance/404' };
    }

    return { allowed: true };
}